import React from 'react';
import * as styles from './index.module.scss';
import { HeadsetIcon } from '../../../icons/HeadsetIcon';
import { TechSupportIcon } from '../../../icons/TechSupportIcon';
import { CogIcon } from '../../../icons/CogIcon';

const GET_IN_TOUCH_ITEMS = [
  {
    Icon: TechSupportIcon,
    label: 'Sales Enquiries',
    tel: '01202662552',
    displayNumber: '01202 662552',
  },
  {
    Icon: HeadsetIcon,
    label: 'Technical',
    tel: '01202662505',
    displayNumber: '01202 662505',
  },
  {
    Icon: CogIcon,
    label: 'Spares',
    tel: '01202662525',
    displayNumber: '01202 662525',
  },
];

export const FooterGetInTouch = () => {
  return (
    <section className={styles.getInTouchColumn}>
      <p className={styles.listTitle}>Get in Touch</p>
      <ul className={styles.getInTouchList}>
        {GET_IN_TOUCH_ITEMS.map(({ Icon, label, tel, displayNumber }, index) => (
          <li key={index} className={styles.getInTouchItem}>
            <span className={styles.getInTouchIcon}>
              <Icon />
            </span>
            <span className={styles.getInTouchContent}>
              <span className={styles.getInTouchLabel}>{label}</span>
              <a className={styles.getInTouchTel} href={`tel:${tel}`}>
                {displayNumber}
              </a>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};
